export default "__VITE_ASSET__fb83e2ae__"